import { takeLatest } from 'redux-saga';
import { put, call, fork } from 'redux-saga/effects';
import { LOAD_PAYMENTS, LOAD_PAYMENTS_ERROR, LOAD_PAYMENTS_SUCCESS } from './constants';
import { getPaymentsData } from '../../utils/jsonapi-functions/payments';

export function* loadPayments(action) {
  const id = action.id;

  try {
    const paymentsData = yield call(getPaymentsData, id);
    yield put({ type: LOAD_PAYMENTS_SUCCESS, data: paymentsData });
  } catch (error) {
    yield put({ type: LOAD_PAYMENTS_ERROR, error: error.message });
  }
}

export function* watchPayments() {
  yield takeLatest(LOAD_PAYMENTS, loadPayments);
}

export default function* paymentsSagas() {
  yield [fork(watchPayments)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/payments/sagas.js
 **/